import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  useSearchState,
  useSearchDispatch,
} from '../../../hooks/use_search_state';
import { toggleIds } from '../../../utils/togglers';
import { findIds } from '../../../utils/finders';
import FilterButton from './filter_button';

export default function Merchants(props) {
  const {
    affiliateMerchants,
    unfilteredResults,
    loading,
    houseKeeping,
  } = props;

  const {
    merchantIds,
  } = useSearchState();

  const {
    setMerchantIds,
  } = useSearchDispatch();

  const merchants = useMemo(() => {
    const includedMerchantIds = findIds(unfilteredResults, 'lngMerchantId');
    return affiliateMerchants?.filter((merchant) => includedMerchantIds.has(merchant.id))
      .sort((a, b) => a.name.localeCompare(b.name)) || [];
  }, [affiliateMerchants, unfilteredResults]);

  return (
    <div className="snapgadget-search-facet snapgadget-search-facet-merchants">
      <h2>Merchants</h2>
      <div className="snapgadget-search-facet-contents">
        {loading
          ? <div className="snapgadget-search-facet-group">Loading merchants</div>
          : merchants.map((merchant) => (
            <div key={merchant.id} className="snapgadget-button-wrapper">
              {
                merchant.url
                && (
                  <a href={merchant.url} target="_blank" rel="external noreferrer noopener">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="16px" height="16px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20">
                      <path d="M9 3h8v8l-2-1V6.92l-5.6 5.59l-1.41-1.41L14.08 5H10zm3 12v-3l2-2v7H3V6h8L9 8H5v7h7z" fill="currentColor" />
                    </svg>
                  </a>
                )
              }
              <FilterButton
                selected={merchantIds.indexOf(merchant.id) >= 0}
                name={merchant.name}
                onClick={() => {
                  houseKeeping();
                  toggleIds(merchantIds, setMerchantIds, [merchant.id]);
                }}
              />
            </div>
          ))}
      </div>
    </div>
  );
}

Merchants.propTypes = {
  affiliateMerchants: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  })),
  unfilteredResults: PropTypes.arrayOf(PropTypes.shape({
    lngMerchantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  loading: PropTypes.bool,
  houseKeeping: PropTypes.func.isRequired,
};

Merchants.defaultProps = {
  affiliateMerchants: [],
  unfilteredResults: [],
  loading: false,
};
